import api from "./api"

class AdminService {
  // User Management
  async getUsers(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return api.get(`/admin/users?${queryString}`)
  }

  async createUser(userData) {
   
    return api.post("/admin/users", userData)
  }

  async updateUser(userId, userData) {
    return api.put(`/admin/users/${userId}`, userData)
  }

  async deleteUser(userId) {
    return api.delete(`/admin/users/${userId}`)
  }

  async toggleUserStatus(userId) {
    return api.patch(`/admin/users/${userId}/toggle-status`)
  }

  // System Statistics
  async getSystemStats() {
    return api.get("/admin/stats")
  }

  async getUserActivity(params = {}) {
    const queryString = new URLSearchParams(params).toString()
    return api.get(`/admin/activity?${queryString}`)
  }

  // Bulk Operations
  async bulkUpdateUsers(userIds, updateData) {
    return api.patch("/admin/users/bulk", { userIds, updateData })
  }

  async bulkDeleteUsers(userIds) {
    return api.delete("/admin/users/bulk", { data: { userIds } })
  }

  // System Settings
  async getSystemSettings() {
    return api.get("/admin/settings")
  }

  async updateSystemSettings(settings) {
    return api.put("/admin/settings", settings)
  }
}

export default new AdminService()
